var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "baseInfoManage" },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            inline: "",
            "label-width": "130px"
          }
        },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("table.precinctName"),
                    prop: "areaName"
                  }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "720px" },
                    attrs: { clearable: "", type: "text" },
                    model: {
                      value: _vm.childData.areaName,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "areaName", $$v)
                      },
                      expression: "childData.areaName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("table.precinctPhone"),
                    prop: "areaPhone"
                  }
                },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: { clearable: "", type: "text" },
                    model: {
                      value: _vm.childData.areaPhone,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "areaPhone", $$v)
                      },
                      expression: "childData.areaPhone"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.id"), prop: "areaOrder" } },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: { clearable: "", type: "text" },
                    model: {
                      value: _vm.childData.areaOrder,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "areaOrder", $$v)
                      },
                      expression: "childData.areaOrder"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("table.precinctAddr"),
                    prop: "areaAddr"
                  }
                },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: { clearable: "", type: "text" },
                    model: {
                      value: _vm.childData.areaAddr,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "areaAddr", $$v)
                      },
                      expression: "childData.areaAddr"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.greenArea") } },
                [
                  _c("el-input-number", {
                    staticClass: "form-item-width",
                    attrs: { clearable: "", min: 0 },
                    model: {
                      value: _vm.childData.greenArea,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "greenArea", $$v)
                      },
                      expression: "childData.greenArea"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.usableArea") } },
                [
                  _c("el-input-number", {
                    staticClass: "form-item-width",
                    attrs: { clearable: "", min: 0 },
                    model: {
                      value: _vm.childData.useArea,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "useArea", $$v)
                      },
                      expression: "childData.useArea"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.shareArea") } },
                [
                  _c("el-input-number", {
                    staticClass: "form-item-width",
                    attrs: { clearable: "", min: 0 },
                    model: {
                      value: _vm.childData.poolArea,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "poolArea", $$v)
                      },
                      expression: "childData.poolArea"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.greeningRate") } },
                [
                  _c("el-input-number", {
                    staticClass: "form-item-width",
                    attrs: { clearable: "", min: 0, max: 100 },
                    model: {
                      value: _vm.childData.greenRate,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "greenRate", $$v)
                      },
                      expression: "childData.greenRate"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.plotRatio") } },
                [
                  _c("el-input-number", {
                    staticClass: "form-item-width",
                    attrs: { clearable: "", min: 0, max: 100 },
                    model: {
                      value: _vm.childData.volumeRatio,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "volumeRatio", $$v)
                      },
                      expression: "childData.volumeRatio"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.buildTime") } },
                [
                  _c("el-date-picker", {
                    staticClass: "form-item-width",
                    attrs: {
                      clearable: "",
                      type: "date",
                      placeholder: "选择日期",
                      format: "yyyy 年 MM 月 dd 日",
                      "value-format": "yyyy-MM-dd"
                    },
                    model: {
                      value: _vm.childData.buildingDate,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "buildingDate", $$v)
                      },
                      expression: "childData.buildingDate"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("table.completionTime") } },
                [
                  _c("el-date-picker", {
                    staticClass: "form-item-width",
                    attrs: {
                      clearable: "",
                      type: "date",
                      placeholder: "选择日期",
                      format: "yyyy 年 MM 月 dd 日",
                      "value-format": "yyyy-MM-dd"
                    },
                    model: {
                      value: _vm.childData.deliveryDate,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "deliveryDate", $$v)
                      },
                      expression: "childData.deliveryDate"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }